<h3>Enter your Email</h3>
<mat-form-field class="login-field-wrap">
  <mat-label>Email:</mat-label>
  <input matInput type="email" placeholder="Email" [(ngModel)]="email" name="email">
</mat-form-field>
<div class="dialog-btn-wrap">
  <button mat-raised-button color="primary" (click)="onSubmit()">Submit</button>
  <button mat-raised-button color="accent" (click)="cancel()">Cancel</button>
</div>

